import React, { useState, useEffect } from "react";
// import "./Newlp.css";
import "../../Pages/packageDetailsPage/Newlp.css";
import { useSelector, useDispatch, connect } from "react-redux";
import { useLocation } from "react-router";
import { BsPaperclip } from "react-icons/bs";
import { FaUserCircle, FaMapPin, FaWhatsappSquare } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import Loader from "../Loader/Loader";
import { BiPlusMedical } from "react-icons/bi";
import { RiWhatsappFill } from "react-icons/ri";
//IMPORTING ACTIONS FOR REEDUX API CALL
import {
  getAllImagingPackageList,
  getCity,
  uploadLp,
  getCall,
} from "../../Redux/Actions";
import { Modal } from "react-responsive-modal";
// import './Imaging.css';

const ImagingForm = (props) => {
  const {
    test,
    position,
    butname,
    title,
    formId,
    isLp,
    isImagine,
    lpNumber,
    upload,
    hide,
  } = props;
  const [userName, setUserName] = useState("");
  const [number, setNumber] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [userCity, setUserCity] = useState("");
  const [nameError, setNameEror] = useState("");
  const [cityError, setCityError] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [displayCityList, setDisplay] = useState(true);
  const [success, setSucess] = useState(false);
  const [checkboxState, setCheckboxState] = useState(true);
  const [disable, setDisable] = useState(true);
  const [openSuccModel, setSucc] = useState(false);

  const [testName, setTestName] = useState("");
  const [displayTestName, setDisplayCity] = useState(true);
  const [previewName, setPreview] = useState(
    "Upload a Prescription (optional)"
  );
  const [previewError, setFileError] = useState("");
  const [filename, setFilename] = useState("");
  const [fileSelected, setFileSelected] = useState();
  // console.log("lp number", lpNumber, fileSelected);

  const imagineData = useSelector((state) => state.getImgPackagesReducer);
  console.log("imagine data", imagineData);
  const { loading: imagineDataLoading } = imagineData;
  useEffect(() => {
    if (isImagine) {
      setNumber("898 898 0101");
    } else if (isLp || lpNumber) {
      setNumber(lpNumber);
    } else {
      setNumber("898 898 8787");
    }
  }, [isImagine, isLp]);
  //cont
  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  useEffect(() => {
    if (
      testName == "" ||
      userName == "" ||
      userCity == "" ||
      userNumber == ""
    ) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [testName, userName, userCity, userNumber]);
  //calling city name api
  useEffect(() => {
    dispatch(getCity());
  }, []);
  useEffect(() => {
    dispatch(getAllImagingPackageList());
  }, []);

  //comment
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  const cityList = useSelector((state) => state.cityList);
  const { cities, loading } = cityList;

  const dispatch = useDispatch();

  //   const handelCityChange = (e) => {
  //     document.getElementById("cityList").classList.remove("displayNone");

  //     userCity(e.target.value);
  //   };
  //use location imported
  const location = useLocation();
  ///${position}

  var url = `https://redcliffelabs.com${location.pathname}/${
    position ? position : ""
  }/${location.search}`;

  //var url = `https://redcliffelabs.com${location.pathname}/${position}`;

  //HANDEL USERNAME FUNCTON BELOW THIS COMMENT
  const handelUserName = (e) => {
    setUserName(e.target.value);
    setDisplayCity(false);
    setDisplay(false);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror(" Invalid User Name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };

  //handel file change

  //changefilein base 64 string
  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const handelfile = (e) => {
    // console.log("filename ", e.target?.files[0]?.name);
    setFileSelected(e.target?.files[0]);

    var myTruncatedString =
      e.target?.files[0]?.name?.substring(0, 10) + e.target?.files[0]?.type;

    console.log(myTruncatedString, "Kaati hue value");

    setPreview(myTruncatedString);

    const filePath = e.target.value;
    var allowedExtensions = /(\.png|\.pdf|\.jpg|\.jpeg)$/i;

    if (e.target?.files[0]?.size > 5000000) {
      setFileError("File size should be less then 5 MB");
    } else if (allowedExtensions.exec(filePath)) {
      setPreview(e.target.files[0].name);

      var myTruncatedString =
        e.target?.files[0]?.name.substring(0, 10) +
        "." +
        e.target?.files[0]?.type;

      setPreview(myTruncatedString);

      setFileError("");
      var file = e.target?.files[0];
      getBase64(file).then((data) => {
        setFilename(data);
        // console.log(data);
      });
    } else {
      setFilename("");
      // console.log("inside else", e.target?.files[0]);
      setFileError("invalid File Type");
    }
    e.target.value = "";
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number");
      return false;
    } else {
      return true;
    }
  };

  const handleCheckChange = (e) => {
    setCheckboxState(!checkboxState);
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e) => {
    setUserNumber(e.target.value);
    setPhoneEror("");
    setDisplayCity(false);
    setDisplay(false);
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      let formData = new FormData();

      formData.append("name", userName);
      formData.append("mobile", userNumber);
      formData.append("source", "google_lp");
      formData.append("address", userCity);
      formData.append("city", userCity);
      formData.append("url", url);
      if (fileSelected) {
        formData.append("image", fileSelected);
      }

      const body = {
        optin: checkboxState,
        test: testName ? testName : test,
        name: userName,
        phone_no: userNumber,
        source: "Ecommerce",
        city: userCity,
        url,
      };
      console.log(body);
      setUserNumber("");
      setUserName("");
      setTestName("");
      setUserCity("");
      setPreview("Upload a Prescription (opt.)");
      setSucess(true);
      openSucess(true);
      setTimeout(() => {
        setSucess(false);
      }, 2000);
      if (upload) {
        props.leadGenrated(formData);
      } else {
        props.getCall(body);
      }
    }
  };

  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  };

  const handelCityChange = (e) => {
    setUserCity(e.target.value);
    setDisplay(true);
    setDisplayCity(false);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setCityError("");
    if (!e.target.value.match(characterRegex)) {
      setCityError("Invalid City Name");
    }
    if (e.target.value == "") {
      setCityError("");
    }
  };

  const setInputTest = (val) => {
    setTestName(val);
    setDisplayCity(false);
  };
  const handelTestChange = (e) => {
    setTestName(e.target.value);
    setDisplayCity(true);
    setDisplay(false);
  };

  useEffect(() => {
    dispatch(getAllImagingPackageList(testName));
  }, [testName]);

  //model div
  const SuccessModel = ({ number }) => {
    return (
      <div className="SuccessMsg_upload">
        <h2>
          We have received your information. We shall call you in few minutes to
          confirm the details. For any queries please call us at &nbsp;
          <a href={`tel:+91-${number}`} style={{ color: "blue" }}>
            {number}
          </a>{" "}
          - Team Redcliffe Labs
        </h2>
      </div>
    );
  };

  //TEST DATA
  const testFromArray = [
    {
      id: 1,
      title: "MRI SCAN",
    },
    {
      id: 2,
      title: "Smart Full Body Checkup",
    },
    {
      id: 3,
      title: "Covid - 19 RTPCR Test",
    },
    {
      id: 4,
      title: "Fever Panel ",
    },
    {
      id: 5,
      title: "Full Body Checkup",
    },
    {
      id: 6,
      title: "Covid - 19 RTPCR Test",
    },
  ];

  return (
    <form
      onSubmit={handelSubmit}
      className="imagingFormDiv "
      style={{ paddingBottom: "0px" }}
    >
      <div className="form__div" style={{ marginBottom: "10px" }}>
        {/* <h4>Book Your Test</h4> */}
        {/* {isLp ? null : <h4 >{title ? title : "Book Your Test"}</h4>} */}
        {isLp ? null : (
          <h4 className="book">{title ? title : "Book Your Test"}</h4>
        )}
        {upload ? (
          <p style={{ fontSize: "1.7rem" }}>
            Select from our range of 3500+ tests
          </p>
        ) : null}
        {/* //Test Name start */}
        <div>
          {hide ? null : (
            <div className="citySelect">
              <span className="locIcon">
                {" "}
                <BiPlusMedical />{" "}
              </span>

              <input
                style={{ border: "none" }}
                type="text"
                // onBlur={()=> setCityFocus(true)}
                placeholder="Enter Test Name"
                onChange={handelTestChange}
                value={testName}
              />
            </div>
          )}
          <span className="FormError"></span>
          <div
            className={testName ? "cityList top" : "displayNone"}
            id="cityList"
          >
            {imagineDataLoading ? (
              <Loader />
            ) : imagineData &&
              imagineData.ImgPackages &&
              imagineData.ImgPackages.length > 0 ? (
              imagineData.ImgPackages.map((values, index) => {
                if (index < 3) {
                  return testName == "" ? (
                    <div> </div>
                  ) : (
                    <div key={values.id}>
                      <div
                        onClick={() => setInputTest(values.name)}
                        key={index}
                        className={
                          displayTestName ? "cityLIstLP" : "displayNone"
                        }
                      >
                        <span>{values.name}</span>
                      </div>
                    </div>
                  );
                }
              })
            ) : null}
          </div>
        </div>
        {/* Test Name End */}

        <div>
          <div className="form__input numBox">
            <span className="userIcon">
              <FaUserCircle />
            </span>
            <div className="inputDiv">
              <input
                style={{ border: "none" }}
                type="text"
                placeholder="Enter Name"
                onChange={handelUserName}
                value={userName}
              />
            </div>
          </div>
          <span className="FormError">{nameError}</span>
        </div>

        <div>
          <div className="form__input numBox">
            <span className="numIcon">+91</span>
            <div className="inputDiv">
              <input
                style={{ border: "none" }}
                type="text"
                placeholder="Enter Phone Number"
                required
                onChange={handelPhoneChange}
                value={userNumber}
              />
            </div>
          </div>
          <span className="FormError">{phoneError}</span>
        </div>

        {/* </div>   */}
        <div className="citySelect cityDiv numBox">
          <span className="locIcon">
            {" "}
            <MdLocationOn />{" "}
          </span>

          <input
            style={{ border: "none" }}
            type="text"
            // onBlur={()=> setCityFocus(true)}
            placeholder="Enter City"
            onChange={handelCityChange}
            value={userCity}
          />

          <div className={userCity ? "cityList" : "displayNone"} id="cityList">
            {userCity !== "" && citiesFromArray && citiesFromArray.cities
              ? citiesFromArray.cities
                  .filter((name) => {
                    if (userCity == "") {
                      return name;
                    } else if (
                      name.toLowerCase().includes(userCity.toLowerCase())
                    ) {
                      return name;
                    }
                  })
                  .map((values, index) => {
                    if (index < 2) {
                      return (
                        <>
                          <div
                            onClick={() => setInputcity(values)}
                            key={index}
                            className={
                              displayCityList ? "cityLIstLP" : "displayNone"
                            }
                          >
                            <span>{values}</span>
                          </div>
                        </>
                      );
                    }
                  })
              : null}
          </div>
          <span className="FormError">{cityError}</span>
        </div>

        {upload ? (
          <div style={{ marginTop: "2rem" }}>
            <div className="form__input numBox">
              <span className="userIcon">
                <BsPaperclip />
              </span>
              <div className="inputDiv">
                <label style={{ fontSize: "1.9rem", color: "gray" }}>
                  {previewName}

                  <input
                    type="file"
                    hidden
                    id="upload"
                    style={{ border: "none" }}
                    placeholder={previewName}
                    onChange={handelfile}
                  />
                </label>
              </div>
            </div>
            <span className="FormError">
              {" "}
              {previewError == "" ? null : previewError}
            </span>
          </div>
        ) : null}

        <button
          id={formId ? formId : "lpBottom"}
          type="submit"
          disabled={
            isLp
              ? nameError || disable
                ? "disabled"
                : ""
              : nameError
              ? "disabled"
              : ""
          }
          className={
            isLp
              ? nameError || disable
                ? "disabled"
                : ""
              : nameError || cityError
              ? "disabled"
              : ""
          }
        >
          {butname ? butname : "SUBMIT"}
        </button>
      </div>
      <Modal open={openSuccModel} onClose={closeSuccess} center>
        <SuccessModel number={number} />
      </Modal>
    </form>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    leadGenrated: (body) => {
      dispatch(uploadLp(body));
    },
    getCall: (body) => {
      dispatch(getCall(body));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(ImagingForm));
